document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.product-card__figure').forEach((figure) => {
    figure.addEventListener('mouseover', () => {
      if(document.body.classList.contains('no-svg-hover')) return;
      const svgUrl = figure.getAttribute('data-svg-url');
      if(svgUrl) {
        figure.style.backgroundImage = `url('${svgUrl}')`;
        figure.style.backgroundColor = 'transparent';
        figure.style.borderRadius = '0';
      }
    });

    figure.addEventListener('mouseout', () => {
      if(document.body.classList.contains('no-svg-hover')) return;
      if(figure.getAttribute('data-svg-url')) {
        figure.style.backgroundImage = '';
        figure.style.backgroundColor = '';
        figure.style.borderRadius = '';
      }
    });
  });
});
